module.exports = __webpack_public_path__ + "media/bootstrap-icons/thermometer-snow-f4f7aad2.svg";